import { useState, ChangeEvent, FormEvent } from "react";

import { getWebsocketsServiceLocationBase } from '../../common/api/data';
//import { authenticate } from '../../../common/api/auth';
import { SubmitArea } from '../../common/ui/submitarea';

export const SendMessage = () => {

	const SUBMIT_CONTENT_BUTTON = '<input type="submit" value="Submit" />';
	const SUBMIT_CONTENT_DISABLED = '<input type="submit" value="Submit" disabled="disabled" />';
	const SUBMIT_CONTENT_SUBMITTING = 'Submitting...';

	const [submitContent, setSubmitContent] = useState(SUBMIT_CONTENT_DISABLED);
	const [recipient, setRecipient] = useState('me');
	const [subject, setSubject] = useState('');
	const [message, setMessage] = useState('');

	const grabRecipientUserInput = (event : ChangeEvent<HTMLSelectElement>) => {
		setRecipient(event.target.value);
		setSubmitContent(event.target.value && subject && message ? SUBMIT_CONTENT_BUTTON : SUBMIT_CONTENT_DISABLED);
	};

	const grabSubjectUserInput = (event : ChangeEvent<HTMLInputElement>) => {
		setSubject(event.target.value);
		setSubmitContent(event.target.value && recipient && message ? SUBMIT_CONTENT_BUTTON : SUBMIT_CONTENT_DISABLED);
	};

	const grabMessageUserInput = (event : ChangeEvent<HTMLInputElement>) => {
		setMessage(event.target.value);
		setSubmitContent(recipient && event.target.value && subject ? SUBMIT_CONTENT_BUTTON : SUBMIT_CONTENT_DISABLED);
	};

	const handleFormSubmit = (event : FormEvent<HTMLFormElement>) => {
		const payload = JSON.stringify({ recipient: recipient, subject: subject, payload: message, });
		submitData(event, payload);
		setSubmitContent(SUBMIT_CONTENT_SUBMITTING);
	};
	
	const submitData = async (event : FormEvent<HTMLFormElement>, submitBody : string) => {
		event.preventDefault();
		//const token = await authenticate();
		var postRequestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			//headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
			body: submitBody
		};
		fetch(getWebsocketsServiceLocationBase() + '/message', postRequestOptions)
			.then(function(response) {
				setSubmitContent(SUBMIT_CONTENT_DISABLED);
				return response.text();
			}).then(function(data) {
				alert(data); // this will be a string
				setSubmitContent(SUBMIT_CONTENT_BUTTON);
			});
	};

	return (
		<div>
			<strong>Send a Message</strong>
			<br />
			<br />
			<form onSubmit={handleFormSubmit}>
				<table><tbody>
					<tr>
						<td>Recipient(s):</td>
						<td>
							<select value={recipient} onChange={grabRecipientUserInput}>
								<option value='me'>me</option>
								<option value='him'>him</option>
							</select>
						</td>
					</tr>
					<tr>
						<td>Subject:</td>
						<td><input type="text" value={subject} placeholder='subject' onChange={grabSubjectUserInput} /></td>
					</tr>
					<tr>
						<td>Message:</td>
						<td><input type="text" value={message} placeholder='message' onChange={grabMessageUserInput} /></td>
					</tr>
					<tr>
						<td></td>
						<td><SubmitArea content={submitContent} /></td>
					</tr>
				</tbody></table>
			</form>
		</div>
	);
};
